export const categories = [
  { slug: 'rpg', name: '角色扮演', icon: 'ri-gamepad-line', description: '沉浸式角色扮演成人游戏，丰富剧情与角色养成' },
  { slug: 'visual-novel', name: '视觉小说', icon: 'ri-book-open-line', description: '互动式视觉小说，精美CG与多线剧情' },
  { slug: 'simulation', name: '模拟经营', icon: 'ri-building-line', description: '经营模拟类成人游戏，策略与养成并存' },
  { slug: 'action', name: '动作冒险', icon: 'ri-sword-line', description: '动作冒险类成人游戏，紧张刺激的战斗体验' },
  { slug: 'puzzle', name: '解谜益智', icon: 'ri-lightbulb-line', description: '益智解谜类成人游戏，挑战智力的同时享受剧情' },
  { slug: 'mobile', name: '手机游戏', icon: 'ri-smartphone-line', description: '适配手机端的成人游戏，随时随地畅玩' },
];